import { colors } from '@hazadapt-git/public-core-base'
import { Typography } from '@mui/material'
import React, { FC } from 'react'

import { customDarkBlueColor, useStyles } from '../../lib/styles/universal'
import { useWindowSizeUp } from '../../lib/utils'
import { TabGroup, TabGroupProps } from '../organisms'

interface SettingsPageTemplateProps {
    data: { [key: string]: TabGroupProps }
    activeGroup: string
    onGroupNamePress(group: string): void
    loggedIn?: boolean
}

export const SettingsPageTemplate: FC<SettingsPageTemplateProps> = (
    props: SettingsPageTemplateProps
) => {
    const { classes } = useStyles()
    const mediumWindowOrLarger = useWindowSizeUp('md')
    const largeWindowOrLarger = useWindowSizeUp('lg')
    return (
        <div
            className={classes.page}
            style={{
                paddingLeft: '1rem',
                paddingRight: '1rem',
                marginBottom: '3rem',
            }}
        >
            <Typography
                variant={largeWindowOrLarger ? 'h1' : 'h2'}
                component="h1"
                width="100%"
                textAlign="left"
                color={customDarkBlueColor}
                paddingBottom="1rem"
            >
                Settings
            </Typography>
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: mediumWindowOrLarger
                        ? `repeat(${Object.keys(props.data).length}, minmax(0, 1fr))`
                        : 'repeat(2, minmax(0, 1fr))',
                    gap: '0.25rem',
                    width: '100%',
                    minWidth: 0,
                    paddingBottom: '2rem',
                }}
            >
                {Object.keys(props.data).map((k, index) => (
                    <Typography
                        component="p"
                        key={`${k}_groupLabel`}
                        variant={'h4'}
                        color={
                            props.activeGroup === k
                                ? colors.grays.NOIR
                                : colors.grays.NIMBUS
                        }
                        sx={{
                            cursor: 'pointer',
                            minWidth: 0,
                            width: '100%',
                            boxSizing: 'border-box',
                            padding: '0.5rem',
                            textAlign: 'center',
                            overflowWrap: 'anywhere',
                            textDecoration:
                                props.activeGroup === k ? 'underline' : 'none',
                        }}
                        onClick={() => props.onGroupNamePress(k)}
                    >
                        {k === 'General' && props.loggedIn ? 'Profile' : k}
                    </Typography>
                ))}
            </div>
            {Object.keys(props.data).map((k) => (
                <TabGroup
                    {...props.data[k]}
                    key={`${k}_tabGroup`}
                    visible={props.activeGroup === k}
                />
            ))}
        </div>
    )
}
